import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import CampaignReport from './reports/reports';
import SimulationTrainingReport from './simulation-training-report/simulation-training-report';
import TestResults from './test-results/test-results';
import CampaignList from './campaign-list/campaign-list';
import CampaignEdit from './campaign-edit/campaign-edit';
import TestCampaign from './test-campaign/test-campaign';
import DeletedCampaign from './deleted-campaign/deleted-campaign';

export default class Campaign extends Component {
	render() {	
        const { match } = this.props;
		return (
            <Switch>
                <Route path={`${match.path}/`} exact component={ CampaignList }/>
                <Route path={`${match.path}/test-campaign`} exact component={ TestCampaign }/>
                <Route path={`${match.path}/deleted-campaign`} exact component={ DeletedCampaign }/>
                <Route path={`${match.path}/test-results`} exact component={ TestResults }/>
                <Route path={`${match.path}/reports/:campaignId/:simulationId`} exact component={ CampaignReport }/>
                <Route path={`${match.path}/simulation-training-report/:campaignId/:simulationId`} exact component={ SimulationTrainingReport }/>
                <Route path={`${match.path}/:campaignId`} exact component={ CampaignEdit }/>
                <Route path={`${match.path}/:campaignId/:simulationId`} exact component={ CampaignEdit }/>
                <Route render={() => (<Redirect to="/invalid" />)}/>
            </Switch>
		);
	}
}